import { HttpHeaders, HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { GetBaseUrl } from "../../helper/getBaseUrl";

const httpOptions = {
    headers: new HttpHeaders({ "Content-Type": "application/json" }),
};

@Injectable()
export class ApiCalendarService {
    private baseUrl = GetBaseUrl.baseUrl();

    constructor(private http: HttpClient) {}

    public apiIsActive(id_service: number): Observable<any> {
        return this.http.get(this.baseUrl + "/calendar/" + id_service);
    }

    public apiActiveInTheFuture(
        id_service: number,
        date: Date
    ): Observable<any> {
        return this.http.get(
            this.baseUrl +
                "/calendar/isOpen/" +
                id_service +
                "?date=" +
                date.toISOString()
        );
    }
}
